import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class RecordTransportDriver extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/record/driver'
    super(store, path)
  }
}
